import { useCallback, useMemo, useRef, useState } from 'react';
import { Checkbox as CheckboxAnt } from 'antd';
import { Checkbox as CheckboxMaterial, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';
import { Popover, SearchBox } from '@icp/components';
import { ButtonUI } from '../ButtonElement';
import './MultiSelectDropdownButton.css';
import { useComponentLibrary } from '../../FormRenderCtx';

function MultiSelectDropdownButton(props) {
  const { icon, label, onClick, items, onSelectItem, disabled } = props;
  const [searchText, setSearchText] = useState('');
  const [openMenu, setOpenMenu] = useState(false);
  const anchorEl = useRef(null);
  const componentLibrary = useComponentLibrary();

  const handleSelectItem = useCallback(
    (e, item) => {
      e.preventDefault();
      e.stopPropagation();
      onSelectItem(item);
    },
    [onSelectItem],
  );

  const menuItems = useMemo(() => {
    return items
      .filter((item) => item.label.toLowerCase().includes(searchText.toLowerCase()))
      .map((item) => (
        <div
          key={item.key}
          className="item icp-clickable"
          onClick={(e) => handleSelectItem(e, item)}
        >
          {componentLibrary === 'material-ui' ? (
            <FormControlLabel
              control={
                <CheckboxMaterial
                  checked={item.checked}
                  indeterminate={item.indeterminate}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
                />
              }
              label={item.label}
              sx={{ '& .MuiFormControlLabel-label': { fontSize: '1rem' } }}
            />
          ) : (
            <CheckboxAnt checked={item.checked} indeterminate={item.indeterminate}>
              {item.label}
            </CheckboxAnt>
          )}
        </div>
      ));
  }, [componentLibrary, handleSelectItem, items, searchText]);

  return (
    <>
      <div className="split-button">
        <ButtonUI icon={icon} className="split-button-main" onClick={onClick} disabled={disabled}>
          {label}
        </ButtonUI>
        <ButtonUI
          className="split-button-arrow"
          icon="oct:chevron-down"
          onClick={() => setOpenMenu(true)}
          disabled={disabled}
          ref={anchorEl}
        />
      </div>
      <Popover
        className="icp-table-column-select"
        anchorEl={anchorEl.current}
        open={openMenu}
        placement="bottom-end"
        onClose={() => {
          setOpenMenu(false);
          setSearchText('');
        }}
      >
        <SearchBox
          open={true}
          suppressSpeech={true}
          autoFocus={true}
          debounce={false}
          onSearch={setSearchText}
        />
        <div className="icp-table-menu icp-thin-scrollbar multi-select-dropdown-menu">
          {menuItems}
        </div>
      </Popover>
    </>
  );
}

MultiSelectDropdownButton.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      indeterminate: PropTypes.bool,
      checked: PropTypes.bool,
    }),
  ),
  onSelectItem: PropTypes.func,
  disabled: PropTypes.bool,
};

export default MultiSelectDropdownButton;
